import { render } from "./FooterComp.vue?vue&type=template&id=19a25a3c&scoped=true&ts=true"
import script from "./FooterComp.vue?vue&type=script&lang=ts"
export * from "./FooterComp.vue?vue&type=script&lang=ts"

import "./FooterComp.vue?vue&type=style&index=0&id=19a25a3c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a25a3c"]])

export default __exports__